/* eslint-disable @typescript-eslint/no-explicit-any -- U2000Input* form handlers */
import U2000InputText from "../../../../u2000Core/components/formControls/input/U2000InputText";
import U2000Label from "../../../../u2000Core/components/formControls/label/U2000Label";
import type { TFunction } from "i18next";
import { NS } from "../../../U3105";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import type { U3105PayrollYearFormRow } from "../../../U3105Service";
import U3105PayrollPeriodsSection from "./U3105PayrollPeriodsSection";

interface U3105PayrollYearBodyProps {
  formStateHandlers: U2000FormStateHandlers<U3105PayrollYearFormRow>;
  t: TFunction;
}

function U3105PayrollYearBody({ formStateHandlers, t }: U3105PayrollYearBodyProps) {
  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <h3 className="text-base font-semibold text-gray-900">{t("lblSectionYear", { ns: NS })}</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="flex min-w-0 flex-col gap-1.5">
            <U2000Label htmlFor="yearCode" label={t("lblYearCode", { ns: NS })} required />
            <U2000InputText
              hideLabel
              formStateHandlers={formStateHandlers as any}
              fieldName="yearCode"
              label={t("lblYearCode", { ns: NS })}
              required
            />
          </div>
        </div>
      </div>

      <U3105PayrollPeriodsSection formStateHandlers={formStateHandlers} t={t} />
    </div>
  );
}

export default U3105PayrollYearBody;
